import Vue from 'vue'
Vue.filter('amount', function(value) {
  if (!value) return '0,00'
  value = parseFloat(value)
  if (isNaN(value)) return '-,--'
  // return value
  //   .toFixed(2)
  //   .replace('.', ',')
  //   .replace(/\d(?=(\d{3}))/g, '$&.')
  //   .replace(',00', ',-')
  //return value.toFixed(2).replace('.', ',').replace(',00', ',-');

  return new Intl.NumberFormat({
    maximumSignificantDigits: 2,
    minimalSignificantDigits: 2,
  })
    .format(value)
    .replace(',00', ',-')
})
